import type { HeliosConditionsState, ConditionType } from '..';

export const removeConditionFromIndex = (state: HeliosConditionsState, { payload }: { payload: { type: ConditionType; index: number } }) => {
  if (state[payload.type]?.conditions) {
    state[payload.type]!.conditions!.splice(payload.index, 1);
  }
};
